require("jquery");
require("underscore");
require("backbone");
require("backbone.marionette");
require("backbone.radio");
require("bluebird");
require("bootstrap");
require("bootstrap-validator");
require("./renderer.ts");
require("./main.ts");




//////////////////
// WEBPACK FOOTER
// ./django/project/@static/@modules/common/index.js
// module id = 57
// module chunks = 42